import React from 'react';
import DarkMarketingPage from '../Shared/DarkMarketingPage';
import Vector from '../../../images/marketing/onlineStore/Vector.png';
import HostingEditor from '../../../images/marketing/onlineStore/hosting-editor.jpg';
import Img from '../../../images/marketing/onlineStore/Img.jpg';
import ViewQuilt from '../../../images/marketing/onlineStore/view_quilt.png';

const sections = [
  {
    label: 'STORE PAGE',
    icon: Vector,
    title: 'All the tools you need',
    description:
      "Don't miss a sale because of some problem. Our system will help you sell more product faster and better. Track your revenue and make sure you're making the sales to succeed.",
    link: '/onlinestore',
    image: HostingEditor,
  },
  {
    label: 'TEMPLATE',
    icon: ViewQuilt,
    title: 'eCommerce Templates',
    description:
      "We make it simple to setup your store so you can focus on the business instead of the tech. If we don't have a template you need, just let us know and we will build one for you.",
    link: '/onlinestore',
    image: Img,
    reverse: true,
  },
];

const quickTags = [
  'Store Builder',
  'Revenue Tracking',
  'Checkout Ready',
  'Template Catalog',
  'Fast Launch',
  'Business Focused',
];

const OnlineStoreContent = ({ history }) => (
  <DarkMarketingPage
    history={history}
    title="EditPage Online Store"
    subtitle="EditPage offers a simple ecommerce solution to get you into business."
    sections={sections}
    quickTags={quickTags}
  />
);

export default OnlineStoreContent;
